// extracted by mini-css-extract-plugin
module.exports = {"advertisers-page":"advertisers_advertisers-page__2ArqT","overflow-hidden-container":"advertisers_overflow-hidden-container__1p6Sm"};